// #region Imports
import { defineComponent, h, resolveComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-dynamic-view',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        dataobject: {
            type: Object,
            required: true,
        }
    },
    render() {
        // #region Check
        if (utils.isEmpty(this.metadata) || this.metadata === undefined) {
            return h('div', {}, {
                default() {
                    const children = [];
                    return children;
                }
            });
        }
        // #endregion
        // #region Children
        const getChildren = (Components) => {
            const children = [];
            if (Components === undefined) {
                return children;
            }
            if (Components.length === 0) {
                return children;
            }
            Components.forEach((e) => {
                children.push(h(resolveComponent("g-dynamic"), { metadata: e, dataobject: this.dataobject }, {
                    default() {
                        return getChildren(e.components);
                    }
                }));
            });
            return children;
        };
        // #endregion
        // #region Final
        //Attributes
        let tData = this.metadata.content?.attributes ?? {};
        let tMetadata = this.metadata.content;
        //Render
        return h('div', tData, {
            default() {
                return getChildren(tMetadata.components);
            }
        });
        // #endregion
    },
});
// #endregion
